var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"type":"primary","loading":_vm.exportLoading},on:{"click":_vm.exportClick}},[_c('a-icon',{attrs:{"type":"cloud-download"}}),_vm._v("导出 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }